"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const soundButton_1 = __importDefault(require("@components/buttons/soundButton"));
const Item = styled_components_1.default.div `
  background: transparent;
  padding: 5px 40px 5px 20px;
  border: 1px dashed #6E76FB;
  border-radius: 25px;
  cursor: pointer;
  user-select: none;
  font-size: 32px;
  font-weight: 700;
  color: #6E76FB;
  line-height: 100%;
  font-family: Phenomena;
  transition: background-color 0.2s ease-in-out;
  border: ${(props) => (props.isCorrect !== undefined ? (props.isCorrect ? '1px dashed #3CB949' : '1px dashed #FE2B45') : '1px dashed #6E76FB')};
  color: ${(props) => (props.isCorrect !== undefined ? (props.isCorrect ? '#3CB949' : '#FE2B45') : '#6E76FB')};

  background-color: ${(props) => (props.isHovering ? '#e0e0e0' : 'transparent')};
  position: relative;
`;
const WordItem = ({ wordObj, isHovering, onHover, onLeave, isDragging, dragRef, handlePlayAudio, zone, }) => {
    const imageRef = (0, react_1.useRef)(null);
    const [imageWidth, setImageWidth] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (imageRef.current) {
            const width = imageRef.current.offsetWidth;
            setImageWidth(width);
        }
    }, [wordObj.hint]);
    return (react_1.default.createElement(Item, { ref: dragRef, isCorrect: zone === 'sentence' ? wordObj === null || wordObj === void 0 ? void 0 : wordObj.isCorrect : undefined, isHovering: isHovering, style: { opacity: isDragging ? 0.5 : 1 }, onMouseEnter: onHover, onMouseLeave: onLeave },
        react_1.default.createElement("div", { style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '10px',
                width: '100%'
            } },
            react_1.default.createElement("button", { onClick: handlePlayAudio, style: {
                    position: 'absolute',
                    top: 10,
                    right: 5,
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    padding: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 24,
                    height: 24,
                }, "aria-label": "Play sound" },
                react_1.default.createElement(soundButton_1.default, null)),
            react_1.default.createElement("span", { style: { width: imageWidth ? `${imageWidth}px` : 'auto', textAlign: 'left' } }, wordObj.content),
            react_1.default.createElement("img", { ref: imageRef, src: wordObj.hint, alt: "", style: {
                    display: 'block',
                    maxWidth: 'min-content',
                    height: 'auto',
                    width: '100%'
                } }))));
};
exports.default = WordItem;
